<template>
  <AppLoadingContainer :predicate="isLoading">
    <div class="card-body">
      <div class="mb-2 text-right">
        <button @click="showAddNoteModal" class="btn btn-success d-print-none"><i class="fa fa-plus"></i>Add Note</button>
      </div>
      <BTable :busy="isLoading" :fields="tableFields" :items="notes" :responsive="true" primary-key="id" show-empty striped table-class="table-align-middle">
        <template v-slot:cell(actions)="row">
          <button @click="onDeleteClick(row.item)" class="btn btn-danger btn-sm d-print-none" type="button">
            <i class="fa fa-trash"></i> Delete
          </button>
        </template>
        <template v-slot:cell(note)="row">
          <p style="width:550px; word-wrap:break-word;">{{ row.item.note }}</p>
        </template>
        <template v-slot:cell(createdDate)="row">
          <span>{{ row.item.createdDate | moment('MM/DD/YYYY') }}</span>
        </template>
      </BTable>
    </div>

    <AppModalConfirm :visible="deletingRow" @close="deletingRow=null" @confirm="onDeleteConfirmed(deletingRow)">
      <template v-slot:header>Confirm</template>
      <p v-if="deletingRow">Are you sure you want to delete the note?</p>
    </AppModalConfirm>

    <b-modal header-class="bg-maroon text-white" id="add-note-modal" ref="addNoteModal" title="Add Note" @ok="onAddNote">
      <b-form @submit.stop.prevent="onAddNote">
        <b-form-group label="Note">
          <b-form-textarea v-model="newNote" rows="4" required></b-form-textarea>
        </b-form-group>
      </b-form>
      <template v-slot:modal-footer="{ cancel }">
        <button :disabled="isSubmitting" class="btn btn-primary" type="submit" @click="onAddNote">Save</button>
        <button @click="cancel" class="btn btn-danger">Close</button>
      </template>
    </b-modal>
    <div class="card-footer d-print-none text-right">
        <RouterLink :to="{ name: 'VISAs' }" class="btn btn-danger"
          >Back</RouterLink
        >
      </div>
  </AppLoadingContainer>
</template>

<script>
import AppLoadingContainer from "@/components/shared/AppLoadingContainer";
import AppModalConfirm from "@/components/shared/AppModalConfirm";
import PersonVisaService from "@/services/PersonVisaService";
import { ToastType } from "@/services/models/shared/ToastType";

export default {
  components: {
    AppLoadingContainer,
    AppModalConfirm,
  },
  data() {
    return {
      notes: [],
      deletingRow: null,
      isLoading: false,
      newNote: '',
      isSubmitting: false,
      tableFields: [
        { key: 'actions', label: '', thStyle: 'width:150px' },
        { key: 'note', label: 'Note' },
        { key: 'createdByPersonName', label: 'Added By' },
        { key: 'createdDate', label: 'Date' },
      ],
    };
  },
  methods: {
    loadData() {
      this.isLoading = true;
      PersonVisaService.getPersonVisaNoteList(this.$route.params.id)
        .then((response) => {
          if (response) {
            this.notes = response;
          } else {
            this.notes = []; // Set to an empty array if no notes are found
          }
        })
        .catch(() => {
          this.alert(ToastType.Danger, 'Failed to load notes');
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    showAddNoteModal() {
      this.$refs.addNoteModal.show();
    },
    onAddNote() {
      this.isSubmitting = true;
      const data = {
        note: this.newNote,
        createdByPersonId: this.$store.state.user.id,
      };
      PersonVisaService.addPersonVisaNote(this.$route.params.id, data)
        .then(() => {
          this.alert(ToastType.Success, 'The note was successfully added');
          this.loadData(); // Reload the notes
        })
        .catch(() => {
          this.alert(ToastType.Danger, 'Failed to add note');
        })
        .finally(() => {
          this.isSubmitting = false;
          this.$refs.addNoteModal.hide();
          this.newNote = ''; // Clear the input field after submission
        });
    },
    onDeleteClick(note) {
      this.deletingRow = note;
    },
    onDeleteConfirmed(deletingRow) {
      PersonVisaService.deletePersonVisaNote(deletingRow.id)
        .then(() => {
          this.alert(ToastType.Success, 'The note was successfully deleted');
          this.loadData();
        })
        .catch(() => {
          this.alert(ToastType.Danger, 'Failed to delete the note');
        })
        .finally(() => {
          this.deletingRow = null;
        });
    },
  },
  created() {
    this.loadData();
  },
};
</script>
